import React from 'react';

import Spinner from 'Shared/components/Spinner';

import './SavingLoader.scss';

function SavingLoader() {
  return (
    <div className="saving-loader d-flex align-items-center">
      <div className="ml-2 mr-1">
        <Spinner
          color="#9498A4"
          spinnerClassName="spinner-border-sm"
          activeIf
          spinnerStyles={{ width: '14px', height: '14px' }}
        />
      </div>
      Saving...
    </div>
  );
}

export default SavingLoader;
